import { Navigate, Outlet, useSearchParams, useNavigate } from "react-router-dom";
import { refreshUser } from "./store/actions";
import { useDispatch } from "react-redux";

const ProtectedRoute = ({ isAuth, children, user }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const currentUser = searchParams.get("email");

  const handleLogout = (e) => {
    localStorage.clear();
    dispatch(refreshUser());
  };

  if (!isAuth) {
    return <Navigate to="/login" replace />;
  } else {
    if(user){
      if(currentUser===null || currentUser===user?.email) {
        // if(user?.kyc === false){
        //   <Navigate to="/kyc" replace />;
        // } else 
          if (user?.creationSource === "BACKEND" && !user?.resetPassword){
          <Navigate to="/change-password" replace />
        } else {
          if(currentUser) {
            navigate("/");
          }else {
            return children
          }
        }
      } else {
        handleLogout();
      }
    }
  }
};

export default ProtectedRoute;

export const KYCRoute = ({ isAuth, children, user }) => {
  if (!isAuth) {
    return 
  } else {
    if (user) {
      if (!user?.kyc) {
        return children;
      } else {
        <Navigate to="" replace />
      }
    }
  }
};

export const ProfileRoute = ({ isAuth, children, user }) => {
  if (!isAuth) {
    return 
  } else {
    if (user) {
      if (user?.creationSource === "BACKEND" && !user?.resetPassword) {
        <Navigate to="/change-password" replace/>
        return children;
      } else {
        <Navigate to="" replace />
      }
    }
  }
};

export const NotProtectedRoute = ({ isAuth, children, user }) => {
  if (isAuth) {
    // if (user) {
      // if (!user?.kyc) {
      //   return <Navigate to="/kyc" replace />;
      // } else {
        return <Navigate to="/" replace />;
    //   }
    // }
  }

  return children;
};
